/**
 * Service for Capital Accounts API calls.
 */

import { apiClient } from '../utils/api-client';
import type { FundCapitalAccounts } from '../types/capital-accounts';

class CapitalAccountsService {
  private baseUrl = '/capital-accounts';

  /**
   * Get capital accounts for all investors in a fund.
   *
   * @param fundId - UUID of the fund
   * @returns Fund capital accounts with investor list and totals
   */
  async getFundCapitalAccounts(fundId: string): Promise<FundCapitalAccounts> {
    return apiClient.get(`${this.baseUrl}/funds/${fundId}`);
  }
}

export const capitalAccountsService = new CapitalAccountsService();
